import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as BuscaSvg } from '../../assets/icons/busca.svg';
import { ReactComponent as FecharSvg } from '../../assets/icons/fechar.svg';
import { ReactComponent as FrequentesSvg } from '../../assets/icons/frequentes.svg';
import { ReactComponent as TopoSvg } from '../../assets/icons/arrow-up.svg';
import { ReactComponent as ArrowDownTotem } from '../../assets/icons/arrowDownTotem.svg';
import { ReactComponent as ArrowUpTotem } from '../../assets/icons/arrowUpTotem.svg';
import { ReactComponent as HomeSvg } from '../../assets/icons/house-home.svg';
import { ReactComponent as VoltarTotemSvg } from '../../assets/icons/voltar-seta.svg';
import { ReactComponent as AjudaSvg } from '../../assets/icons/ajuda.svg';
import { ReactComponent as LogOutSvg } from '../../assets/icons/logout-totem2.svg';
import { ReactComponent as AdicionarSvg } from '../../assets/icons/adicionar.svg';
import { ReactComponent as BottomSvg } from '../../assets/icons/arrow-down.svg';
import LikePng from '../../assets/icons/like.png';
import Top from '../../assets/icons/top.png';
import { ReactComponent as PinSvg } from '../../assets/icons/pin.svg';
import UnlikePng from '../../assets/icons/unlike.png';
import WhatsAppPng from '../../assets/images/whatsapp.png';
import {
  BotaoExcluir,
  BotaoImpressao,
  BotaoLike, BotaoLink, BotaoLinkLogin, BotaoNude, BotaoNudePesquisa, BotaoNudeTotem, BotaoUnlike,
} from '../../styles/base';
import {
  BotaoAba, BotaoAdicionar, BotaoAjuda, BotaoForm, BotaoFrequentes, BotaoLocalizacao, LinkNude, BotaoInformacaoAcompanhamento, BotaoTopo, BotaoWhats, BotaoWhats2, BotaoUpTotem, BotaoDownTotem, BotaoUpTotemModal, BotaoDownTotemModal, BotaoFormTotem, BotaoUpTotemAcompanhamento, BotaoAbaTotem, BotaoVoltarTotem, BotaoSairTotem, BotaoVoltarTotemNude,
  BotaoStatusAcompanhamento,
} from './BotaoEstilo';
import { fecharModalServico } from '../../app/slices/modalSlice';

const Botao = ({
  ajudaAcompanhamento,
  label, link, linkLogin, onClick, style, fechar, localizacao, whats, whats2, submitTotem, routerTotem, sair, home,
  fill, cep, router, to, aba, ativo, linkRouter, like, unlike, totem, up, down, fecharTotem, abaTotem, voltar,
  impressao, adicionar, ajuda, type, sicFrequentes, excluir, sic, cancelar, topo, ajudaTotem, totemUp, totemDown, totemUpModal, totemDownModal, totemUpAcompanhamento, title, busca, statusAcompanhamento, corFundo,
}) => {
  if (voltar) {
    return (
      <BotaoVoltarTotemNude onClick={onClick}>
        <VoltarTotemSvg
          height={48}
          width={48}
        />
        <span style={{ color: '#000000c2', display: 'block', fontSize: 15 }}>Voltar</span>
      </BotaoVoltarTotemNude>
    );
  }
  if (sair) {
    return (
      <BotaoSairTotem onClick={onClick}>
        <LogOutSvg
          height={48}
          width={48}
          fill="#fff"
        />
        <span style={{ color: '#000000c2', display: 'block', fontSize: 15 }}>Sair</span>
      </BotaoSairTotem>
    );
  }
  if (sicFrequentes) {
    return (
      <BotaoFrequentes onClick={onClick}>
        <FrequentesSvg
          height={30}
          width={30}
          fill="#fff"
        />
      </BotaoFrequentes>
    );
  }
  if (topo) {
    return (
      <BotaoAjuda onClick={onClick}>
        <AjudaSvg
          height={31}
          width={31}
        />
      </BotaoAjuda>
    );
  }
  if (ajuda) {
    return (
      <BotaoAjuda onClick={onClick} title={title}>
        <AjudaSvg
          height={31}
          width={31}
        />
      </BotaoAjuda>
    );
  }
  if (totemUp) {
    return (
      <BotaoUpTotem onClick={onClick}>
        <ArrowUpTotem
          height={48}
          width={48}
        />
      </BotaoUpTotem>
    );
  }
  if (totemUpAcompanhamento) {
    return (
      <BotaoUpTotemAcompanhamento onClick={onClick}>
        <ArrowUpTotem
          height={48}
          width={48}
        />
      </BotaoUpTotemAcompanhamento>
    );
  }
  if (totemDown) {
    return (
      <BotaoDownTotem onClick={onClick}>
        <ArrowDownTotem
          height={48}
          width={48}
        />
      </BotaoDownTotem>
    );
  }
  if (totemUpModal) {
    return (
      <BotaoUpTotemModal onClick={onClick}>
        <ArrowUpTotem
          height={30}
          width={30}
        />
      </BotaoUpTotemModal>
    );
  }
  if (totemDownModal) {
    return (
      <BotaoDownTotemModal onClick={onClick}>
        <ArrowDownTotem
          height={30}
          width={30}
        />
      </BotaoDownTotemModal>
    );
  }
  if (ajudaTotem) {
    return (
      <BotaoAjuda onClick={onClick}>
        <AjudaSvg
          height={31}
          width={31}
        />
      </BotaoAjuda>
    );
  }
  if (whats) {
    return (
      <BotaoWhats>
        <img src={WhatsAppPng} style={{ height: 40, width: 40 }} alt="WhatsApp" />
      </BotaoWhats>
    );
  }
  if (whats2) {
    return (
      <BotaoWhats2>
        <img src={WhatsAppPng} style={{ height: 40, width: 40 }} alt="WhatsApp" />
      </BotaoWhats2>
    );
  }
  if (ajudaAcompanhamento) {
    return (
      <BotaoInformacaoAcompanhamento onClick={onClick}>
        <AjudaSvg
          height={31}
          width={31}
          fill="#fff"
        />
      </BotaoInformacaoAcompanhamento>
    );
  }
  if (adicionar) {
    return (
      <BotaoAdicionar onClick={onClick} title={title} style={style}>
        <AdicionarSvg
          height={28}
          width={28}
          fill="#fff"
        />
      </BotaoAdicionar>
    );
  }
  if (impressao) {
    return (
      <BotaoImpressao type="button" onClick={onClick} style={style}>
        {label}
      </BotaoImpressao>
    );
  }
  if (like) {
    return (
      <BotaoLike
        onClick={onClick}
        style={style}
      >
        <img src={LikePng} style={{ height: 24, width: 24 }} alt="Gostei" />

      </BotaoLike>
    );
  }

  if (unlike) {
    return (
      <BotaoUnlike
        onClick={onClick}
        style={style}
      >
        <img src={UnlikePng} style={{ height: 24, width: 24 }} alt="Não gostei" />
      </BotaoUnlike>
    );
  }

  if (linkRouter) {
    return (
      <LinkNude to={to} onClick={onClick}>
        <BotaoLink type="button" style={style}>
          &bull;
          {' '}
          {label}
        </BotaoLink>
      </LinkNude>
    );
  }

  if (localizacao) {
    return (
      <BotaoLocalizacao type="button" onClick={onClick}>
        <PinSvg height={30} width={30} />
      </BotaoLocalizacao>
    );
  }

  if (abaTotem) {
    return (
      <BotaoAbaTotem ativo={ativo} type="button" onClick={onClick}>
        {label}
      </BotaoAbaTotem>
    );
  }

  if (aba) {
    return (
      <BotaoAba ativo={ativo} type="button" onClick={onClick}>
        {label}
      </BotaoAba>
    );
  }

  if (router) {
    return (
      <LinkNude to={to} onClick={onClick}>
        <BotaoForm type="button" style={style}>
          {label}
        </BotaoForm>
      </LinkNude>
    );
  }

  if (routerTotem) {
    return (
      <LinkNude to={to} onClick={onClick}>
        <BotaoForm
          type="button"
          style={style}
        >
          {label}
        </BotaoForm>
      </LinkNude>
    );
  }

  if (link) {
    return (
      <BotaoLink type="button" style={style} onClick={onClick}>
        &bull;
        {' '}
        {label}
      </BotaoLink>
    );
  }

  if (linkLogin) {
    return (
      <BotaoLinkLogin type="button" style={style} onClick={onClick}>
        {label}
      </BotaoLinkLogin>
    );
  }

  if (fechar) {
    return (
      <BotaoNude type="button" onClick={onClick} style={style}>
        <FecharSvg height={12} width={12} fill={fill} />
      </BotaoNude>
    );
  }

  if (home) {
    return (
      <BotaoNude type="button" onClick={onClick} style={style}>
        <HomeSvg height={18} width={18} fill={fill} />
      </BotaoNude>
    );
  }

  if (fecharTotem) {
    return (
      <BotaoNudeTotem type="button" onClick={onClick} style={style}>
        <FecharSvg height={20} width={20} fill={fill} />
      </BotaoNudeTotem>
    );
  }

  if (excluir) {
    return (
      <BotaoExcluir type="button" onClick={onClick} style={style}>
        <FecharSvg height={9} width={9} fill="#fff" />
      </BotaoExcluir>
    );
  }

  if (cep && totem) {
    return (
      <BotaoNude type="button" onClick={onClick} style={{ marginLeft: 10 }}>
        <BuscaSvg
          style={{
            marginLeft: 10, marginRight: 10, height: 30, width: 30, alignSelf: 'center',
          }}
          fill="#000000"
        />
      </BotaoNude>
    );
  }

  if (cep) {
    return (
      <BotaoNude type="button" onClick={onClick} style={style}>
        <BuscaSvg
          style={{
            marginLeft: 10, marginRight: 10, height: 24, width: 24, alignSelf: 'center',
          }}
          fill="#000000"
        />
      </BotaoNude>
    );
  }

  if (cancelar) {
    return (
      <BotaoForm type={type} onClick={onClick} style={style}>
        {label}
      </BotaoForm>
    );
  }

  if (submitTotem) {
    return (
      <BotaoFormTotem type={type} onClick={onClick} style={style}>
        {label}
      </BotaoFormTotem>
    );
  }
  if (busca) {
    return (
      <BotaoNudePesquisa type="button" onClick={onClick} style={style}>
        <BuscaSvg
          style={{
            height: 24, width: 24,
          }}
          fill="#000000"
        />
      </BotaoNudePesquisa>
    );
  }
  if (statusAcompanhamento) {
    return (
      <BotaoStatusAcompanhamento type="button" onClick={onClick} style={style} corFundo={corFundo} ativo={ativo}>
        {label}
      </BotaoStatusAcompanhamento>
    );
  }
  return (
    <BotaoForm type={type} onClick={onClick} style={style}>
      {label}
    </BotaoForm>
  );
};

Botao.propTypes = {
  label: PropTypes.string,
  link: PropTypes.bool,
  linkLogin: PropTypes.bool,
  onClick: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  style: PropTypes.oneOfType([PropTypes.object]),
  fecharTotem: PropTypes.bool,
  fechar: PropTypes.bool,
  localizacao: PropTypes.bool,
  fill: PropTypes.string,
  cep: PropTypes.bool,
  router: PropTypes.bool,
  routerTotem: PropTypes.bool,
  to: PropTypes.string,
  aba: PropTypes.bool,
  ativo: PropTypes.bool,
  linkRouter: PropTypes.bool,
  like: PropTypes.bool,
  totem: PropTypes.bool,
  unlike: PropTypes.bool,
  impressao: PropTypes.bool,
  adicionar: PropTypes.bool,
  ajuda: PropTypes.bool,
  type: PropTypes.string,
  sicFrequentes: PropTypes.bool,
  ajudaAcompanhamento: PropTypes.bool,
  excluir: PropTypes.bool,
  sic: PropTypes.bool,
  cancelar: PropTypes.bool,
  topo: PropTypes.bool,
  up: PropTypes.bool,
  down: PropTypes.bool,
  whats: PropTypes.bool,
  whats2: PropTypes.bool,
  ajudaTotem: PropTypes.bool,
  totemUp: PropTypes.bool,
  totemDown: PropTypes.bool,
  totemUpModal: PropTypes.bool,
  totemDownModal: PropTypes.bool,
  submitTotem: PropTypes.bool,
  totemUpAcompanhamento: PropTypes.bool,
  abaTotem: PropTypes.bool,
  voltar: PropTypes.bool,
  sair: PropTypes.bool,
  home: PropTypes.bool,
  title: PropTypes.string,
  busca: PropTypes.bool,
  statusAcompanhamento: PropTypes.bool,
  corFundo: PropTypes.string,
};

Botao.defaultProps = {
  label: null,
  link: false,
  linkLogin: false,
  style: null,
  fechar: false,
  fecharTotem: false,
  localizacao: false,
  fill: null,
  cep: false,
  router: false,
  routerTotem: false,
  to: null,
  aba: false,
  ativo: false,
  linkRouter: false,
  like: false,
  unlike: false,
  impressao: false,
  adicionar: false,
  ajuda: false,
  type: 'button',
  sicFrequentes: false,
  excluir: false,
  ajudaAcompanhamento: false,
  topo: false,
  sic: false,
  totem: false,
  up: false,
  down: false,
  cancelar: false,
  whats: false,
  whats2: false,
  ajudaTotem: false,
  totemUp: false,
  totemDown: false,
  totemUpModal: false,
  totemDownModal: false,
  submitTotem: false,
  totemUpAcompanhamento: false,
  abaTotem: false,
  voltar: false,
  sair: false,
  home: false,
  busca: false,
  title: '',
  statusAcompanhamento: false,
  corFundo: '',
};

export default Botao;
